import { Link, useLocation } from 'react-router-dom';

/**
 * Small horizontal tab strip placed at the top of "hub" pages that share
 * a sidebar entry. Each tab is a pill linking to a sibling page; the active
 * one is filled, the others outlined.
 *
 * Props:
 *  tabs: [{ path, label, icon? }]
 */
export const PageTabs = ({ tabs = [], testIdPrefix = 'page-tab' }) => {
  const { pathname } = useLocation();
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="page-tabs">
      {tabs.map(t => {
        const Icon = t.icon;
        const active = pathname === t.path || pathname.startsWith(t.path + '/');
        return (
          <Link
            key={t.path}
            to={t.path}
            data-testid={`${testIdPrefix}-${t.path.replace(/\//g, '-')}`}
            className={`inline-flex items-center gap-2 h-9 px-4 rounded-full text-sm font-medium transition-colors ${
              active
                ? 'bg-[#2D8C8C] text-white shadow-sm'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted/70 border border-transparent'
            }`}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {t.label}
          </Link>
        );
      })}
    </div>
  );
};

export default PageTabs;
